module.exports = __webpack_public_path__ + "img/coinbankB33.2694f525.jpg";